module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-img-005.e0cb56b6.jpg";